export default "__VITE_PUBLIC_ASSET__b97c8c42__"